import React from "react";
import logo from "../../Images/dcwlogotext.png";

const Loading = () => {
  return (
    <div className="preloader">
      <div className="flash-screen">
        <div className="flash-body bg-primary">
          <div className="d-flex justify-content-center align-items-center gap-1">
            <img
              src={logo}
              alt="logoicon"
              style={{ height: "40px" }}
            />
          </div>
          <div className="text-container">
            <h1 className="club-name text-white fw-bold text-2xl">
              DCWAccounting
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
